export default "__VITE_ASSET__D5hAmcS0__"